declare namespace $ {

	export class $shm_hitalama_vk_posts extends $mol_ghost {
		token_str( ): string
		owner_id( ): string
		posts_data( next?: any ): any
		dto( ): $shm_hitalama_vk_posts_dto | null
		collect( ): any
		pending( next?: boolean ): boolean
		post_id( id: any): string
		post_date( id: any): string
		post_likes( id: any): string
		post_reposts( id: any): string
		post_comments( id: any): string
		post_views( id: any): string
	}
	
}

//# sourceMappingURL=posts.view.tree.d.ts.map